import { DigitalWalletPaymentDetails } from './digital-wallet';

export class SubmitDigitalWalletPaymentRequest {
	customerAccountId: string;
	portalId: string;
	bucketKey: number;
	merchantKey: number;
	digitalWalletPaymentDetails: DigitalWalletPaymentDetails;
}
